(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('EditAuthorizedOnuController', EditAuthorizedOnuController);

    EditAuthorizedOnuController.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'OnuData', 'OnuService', 'onuItem'];

    function EditAuthorizedOnuController($rootScope, $scope, $uibModalInstance, OnuData, OnuService, onuItem) {

        // Variables and Objects
        var vm = this;
        vm.requestRunning = false;
        vm.dataOnu = {};

        // Method handler
        vm.close = close;

        // Method API
        vm.update = update;

        // Initialize
        vm.initialize = initialize;


        // Method handler
        function close() {
            if (!vm.requestRunning) {
                $uibModalInstance.dismiss('cancel');
            }
        }

        // Method API
        function update() {
            if (vm.formEditAuthorizedOnu.$valid && !vm.requestRunning) {
                vm.requestRunning = true;
                OnuService.updateNameOnu(vm.dataOnu.id, vm.dataOnu.name.toUpperCase(), vm.dataOnu.description)
                        .then(successUpdate)
                        .catch(errorUpdate);
            }
        }

        // Method request
        function successUpdate(data) {
            vm.requestRunning = false;
            OnuService.successModalConstructor('edit');
            $rootScope.$emit('onuUpdateSuccess', data);
        }

        function errorUpdate(response) {
            vm.requestRunning = false;
            OnuService.errorModalConstructor(response, 'edit');
        }

        // Initialize
        function initialize() {
            vm.dataOnu = {
                id: onuItem.id,
                oltName: onuItem.oltName,
                description: onuItem.description,
                name: onuItem.name,
                meProfile: onuItem.meProfile,
                gponPort: onuItem.gponPort,
                gponSlot: onuItem.gponSlot
            };
        }
        initialize();
    }

})();
